import RightTopArrow from "../../assets/figures/rightTopArrow";

export default function AdmissionsHeroSection(props) {

    return (
        <div>
            <div
                className="paragraph paragraph--type--ixm-blocks-hero-banner paragraph--view-mode--default hero-banner hero-banner__style-2 pb-4 pb-lg-8 bg-gray-200 mb-5"
                style={{ paddingTop: "calc(80px + 2rem)" }}>
                <div className="container">
                    <nav role="navigation" aria-labelledby="system-breadcrumb" className="system-breadcrumbs mb-5">
                        <h2 id="system-breadcrumb" className="visually-hidden">Breadcrumb</h2>
                        <ul className="p-0 m-0 d-none d-lg-flex desktop-breadcrumbs">
                            <li><a href="/" className="transition__all"> <span className="material-icons">home</span>
                            </a><span className="material-icons breadcrumb-chevron">chevron_right</span>
                            </li>
                            <li>
                                Admissions<span className="material-icons breadcrumb-chevron">chevron_right</span>
                            </li>
                        </ul>
                        <ul className="p-0 pt-4 m-0 d-flex d-lg-none mobile-breadcrumbs">
                            <li><a href="/" className="transition__all"> <span className="material-icons">home</span>
                            </a><span className="material-icons breadcrumb-chevron">chevron_right</span>
                            </li>
                            <li> Admissions<span className="material-icons breadcrumb-chevron">chevron_right</span>
                            </li>
                        </ul>
                    </nav>
                    <div className="row justify-content-between align-items-center">
                        <div className="mh-column col-12 col-lg-6 z-1">
                            <h1 className="d-block w-100 fw-bold mb-4" style={{ fontSize: "clamp(2rem, 7vw, 5rem)" }}>
                                <span className="d-block position-relative">
                                    <RightTopArrow/> Admissions
                                </span>
                            </h1>
                            <div className="col-12 col-lg-10">
                                <div>
                                    <p>
                                        How can top students succeed if they're never trusted with something that matters?
                                    </p>
                                </div>
                            </div>
                            <div className="d-flex mt-3 flex-wrap gap-3">
                                <a href="/apply" target="_blank"
                                   className="btn btn-lg btn-danger d-inline-flex align-items-center gap-2 font-semibold">
                                    START AN APPLICATION <span className="material-symbols-outlined">arrow_forward</span>
                                </a>
                            </div>
                        </div>

                        <div className="col-12 col-lg-5 mt-4 mt-lg-n7 position-relative z-0">
                            <div className="bg-white shadow" style={{ padding: "10px" }}>
                                <video className="img-fluid w-100" autoPlay loop muted playsInline>
                                    <source type="video/mp4"
                                            src="https://firebasestorage.googleapis.com/v0/b/extern-academy.firebasestorage.app/o/website%2Fimages%2Fcustom%2Fguy_talking_in_meeting.mp4?alt=media&token=dcbcac6d-fead-42ff-83ab-515bef8d2a79"/>
                                    Your browser does not support the video tag.
                                </video>
                            </div>
                            <img className="img-fluid hero__image-2 d-none d-lg-block" width="50%"
                                 src="https://www.saschina.org/sites/default/files/styles/focal_point_533x638/public/2024-05/4601362b71c96a78d545cb237b4456d6.jpeg.webp?itok=OouSEgD1"
                                 alt="Banner Image 2"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}